import { takeEvery, put, call, all, fork } from 'redux-saga/effects';
import { fetchNotification } from '../../api/notification';
import { fetchSuccess, fetchError } from './actions';
import { NotificationActionTypes } from './types';

function* handleFetch() {
  try {
    const data = yield call(fetchNotification);
    yield put(fetchSuccess(data));
  } catch (err) {
    if (
      err.response &&
      err.response.status &&
      err.response.data &&
      err.response.data.data
    ) {
      yield put(
        fetchError({
          status: err.response.status,
          data: err.response.data.data,
        }),
      );
    } else {
      yield put(fetchError({ status: 500, data: 'An unknown error occured.' }));
    }
  }
}

function* watchFetchRequest() {
  yield takeEvery(NotificationActionTypes.FETCH_REQUEST, handleFetch);
}

function* notificationSaga() {
  yield all([fork(watchFetchRequest)]);
}

export default notificationSaga;
